import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import A1 from '../Images/logo-w.png';
import { useNavigate } from 'react-router-dom'; 
import axios from 'axios'; 

const Login = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false); 
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate(); 

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     const validationErrors = {};
    //     if (!formData.email) validationErrors.email = 'Email is required';
    //     if (!formData.password) validationErrors.password = 'Password is required';

    //     if (Object.keys(validationErrors).length > 0) {
    //         setErrors(validationErrors);
    //         return;
    //     }

    //     setLoading(true);

    //     try {
    //         const response = await axios.post('https://rvapi.emedha.in/auth/api/login', formData);

    //         if (response.status === 200) {
    //             sessionStorage.setItem('token', response.data.token);
    //             sessionStorage.setItem('user', JSON.stringify(response.data.user)); 
    //             navigate('/Dashboard/45g676tr/Dashboard');
    //         }
    //     } catch (error) {
    //         setLoading(false);
    //         if (error.response) {
    //             console.error('Login error:', error.response.data.error);
    //             alert(error.response.data.error);
    //         } else {
    //             console.error('Error:', error.message);
    //             alert('Login failed. Please try again later.');
    //         }
    //     }
    // };



const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage(''); // Clear prior messages

        const validationErrors = {};
        if (!formData.email) validationErrors.email = 'Email is required';
        if (!formData.password) validationErrors.password = 'Password is required';

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post('https://rvapi.emedha.in/auth/api/login', formData);

            if (response.status === 200) {
                sessionStorage.setItem('token', response.data.token);
                sessionStorage.setItem('user', JSON.stringify(response.data.user)); 
                navigate('/Dashboard/45g676tr/Dashboard');
            }
        } catch (error) {
            setLoading(false);
            if (error.response && error.response.data && error.response.data.error) {
                setErrorMessage(error.response.data.error);
            } else {
                setErrorMessage('Unable to log in. Please check your credentials or network connection.');
            }
        }
    };

    return (
        <div
            className="d-flex align-items-center justify-content-center min-vh-100"
            style={{
                background: 'linear-gradient(to right, #6a11cb 0%, #2575fc 100%)',
                padding: '20px',
            }}
        >
            <div
                className="p-4"
                style={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)',
                    width: '100%',
                    maxWidth: '400px',
                }}
            >
                <div className="text-center">
                    <div style={{
      fontFamily: 'Arial, sans-serif',
      fontSize: '40px',
      fontWeight: 'bold',
      color: 'transparent',
      background: 'linear-gradient(to right, #3498db, #8e44ad)', // Gradient effect
      WebkitBackgroundClip: 'text', // Ensures text takes on the gradient color
      textAlign: 'center',
      marginBottom: '15px',
      textTransform: 'uppercase',
      letterSpacing: '2px',
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)', // Shadow for a 3D effect
    }}>
      QuizifyAI
    </div>
                    <h2 className="mb-4" style={{ fontFamily: 'Arial, sans-serif', color: '#333' }}>
                        Welcome Back!
                    </h2>
                </div>

                <form onSubmit={handleSubmit}>
                    {errorMessage && (
                        <div 
                            className="alert alert-danger py-2 px-3 mb-3 d-flex align-items-center" 
                            role="alert" 
                            style={{ 
                                fontSize: '13px', 
                                borderRadius: '8px', 
                                border: '1px solid #fecaca', 
                                backgroundColor: '#fff1f2', 
                                color: '#b91c1c', 
                                lineHeight: '1.4' 
                            }}
                        >
                            <span>⚠️ {errorMessage}</span>
                        </div>
                    )}
                    <div className="mb-3">
                        <label className="form-label" style={{ fontWeight: '500' }}>
                            Email Address
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Enter your email"
                        />
                        {errors.email && <div className="text-danger">{errors.email}</div>}
                    </div>

                    {/* Password Input */}
                    <div className="mb-3">
                        <label className="form-label" style={{ fontWeight: '500' }}>
                            Password
                        </label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Enter your password"
                        />
                        {errors.password && <div className="text-danger">{errors.password}</div>}
                    </div>

                    <div className="d-grid gap-2">
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Logging In...' : 'Login'}
                        </button>
                    </div>
                </form>

                <div className="mt-3 text-center">
                    <a href="/Signup/45g676tr/Signup" className="text-decoration-none text-primary me-3">
                        Create an Account
                    </a>
                    <span> | </span>
                    <a href="/forgotPassword" className="text-decoration-none text-primary">
                        Forgot Password?
                    </a>
                </div>

                <div className="text-center mt-4" style={{ fontSize: '12px', color: '#777' }}>
                    <p>&copy; 2025 Quizifyai. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
};

export default Login;
